import React from 'react';
import {message, useIntl} from '@sail/intl';
import {ContentState, Button} from '../../SharedComponents';

const messages = {
  verifyYourIdentityTitle: message({
    id: 'connectEmbedLib.externalAccount.verifyYourIdentity.title',
    description:
      'The title of a modal that pops up when we require the user to verify their identity with support prior to changing their external account information.',
    defaultMessage: 'Verify your identity',
  }),
  verifyYourIdentityDescription: message({
    id: 'connectEmbedLib.externalAccount.verifyYourIdentity.description',
    description:
      'The description of a modal that pops up when we require the user to verify their identity with support prior to changing their external account information.',
    defaultMessage:
      'To help keep your account secure, we need to verify your identity before updating your payout information.',
  }),
  unsupportableTitle: message({
    id: 'connectEmbedLib.externalAccount.unsupportableTitle',
    description:
      'The title of the modal that lets the user they are not eligible for identity verification.',
    defaultMessage: 'We cannot verify your identity',
  }),
  unsupportableDescription: message({
    id: 'connectEmbedLib.externalAccount.unsupportableDescription',
    description:
      'The description of the modal that lets the user they are not eligible for identity verification',
    defaultMessage:
      'We need to verify your identity before you can change your payout method, however we currently do not have enough information on file. Please update your birthdate to your account to continue. If you are unable to update your birthdate on your account, please contact support.',
  }),
  actionVerifyIdentity: message({
    id: 'connectEmbedLib.externalAccount.verifyYourIdentity.actionVerifyIdentity',
    description: 'The button to attempt to verify the users identity',
    defaultMessage: 'Verify identity',
  }),
};

type Props = {
  onVerifyIdentity?: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  identityVerificationEnabled?: boolean;
};

const Unsupportable = () => {
  const intl = useIntl();
  return (
    <ContentState
      title={intl.formatMessage(messages.unsupportableTitle)}
      description={intl.formatMessage(messages.unsupportableDescription)}
    />
  );
};

const Supportable = ({onVerifyIdentity}: Props) => {
  const intl = useIntl();
  return (
    <ContentState
      title={intl.formatMessage(messages.verifyYourIdentityTitle)}
      description={intl.formatMessage(messages.verifyYourIdentityDescription)}
      actions={
        <Button
          onPress={onVerifyIdentity}
          data-testid="virtual-account-confirmation-verify-identity-button"
        >
          {intl.formatMessage(messages.actionVerifyIdentity)}
        </Button>
      }
    />
  );
};

export const VirtualAccountConfirmation = ({
  onVerifyIdentity,
  identityVerificationEnabled,
}: Props) => {
  if (!identityVerificationEnabled) {
    return <Unsupportable />;
  } else {
    return <Supportable onVerifyIdentity={onVerifyIdentity} />;
  }
};
